import { Component, OnInit } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { LanguageService } from '../language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {
  languages = [
    { code: 'en', label: 'English', flag: 'assets/flags/en.jpg' },
    { code: 'fr', label: 'Français', flag: 'assets/flags/fr.jpg' },
    { code: 'it', label: 'Italiano', flag: 'assets/flags/it.jpg' },
    { code: 'de', label: 'Deutsch', flag: 'assets/flags/de.jpg' },
  ];

  currentLang = 'en';
  currentFlag = 'assets/flags/en.jpg';

  constructor(
    private actionSheetCtrl: ActionSheetController,
    private langService: LanguageService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.subscribeLanguage();
  }

  subscribeLanguage() {
    this.langService.selectedLang.subscribe((lang) => this.setLanguage(lang));
  }

  async onChangeLanguage() {
    const actionSheet = await this.actionSheetCtrl.create({
      mode: 'ios',
      cssClass: 'my-custom-class',
      buttons: await this.prepareLanguageButtons(),
    });
    await actionSheet.present();
  }

  private async prepareLanguageButtons(): Promise<any[]> {
    const actionButtons = this.languages.map((lang) => ({
      text: lang.label,
      handler: () => {
        this.changeLanguage(lang.code);
      },
    }));
    const cancelText = await this.translate.get('Cancel').toPromise();
    actionButtons.push({
      text: cancelText || 'Cancel',
      handler: () => {},
    });

    return actionButtons;
  }

  changeLanguage(lang: string) {
    this.langService.setLanguage(lang);
  }

  private setLanguage(lang: string) {
    const selected = this.languages.find((l) => l.code === lang);
    this.currentLang = selected?.code || 'en';
    this.currentFlag = selected?.flag || 'assets/flags/en.jpg';
  }
}
